import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import { ElementListComponent } from "../ElementListComponent";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  isEng: boolean;
  callbackElement
}

interface State {


}
export class TableComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

  }

  render() {

    let field = this.props.field;
    let editable = this.props.editable;

    if (!field.Visible) return null;

    let controlArray = [];
    let baseName;
    let bindName;

    if (field.FilterField) {
      let parts = field.FilterField.split('.');
      if (parts.length == 3) {
        baseName = parts[0] + '.' + parts[1];
        bindName = parts[2];
      }
      if (parts.length == 2) {
        baseName = parts[0];
        bindName = parts[1];
      }
      if (parts.length == 1) {
        baseName = '';
        bindName = parts[0];
      }
    }



    controlArray.push(<div>{field.Hint}</div>);
    const subSectionList = field.subSectionList;
    subSectionList?.forEach(subSection => {
      if (editable) {
        controlArray.push(
          <div title={field.TooltipENU} style={{ width: '100%' }}>
            <div key={'fd_' + field.Id} title={field.TooltipENU} style={{ width: '100%' }}>
              <ElementListComponent
                key={'sub_list' + field.Id} {...this.props}
                field={this.props.field}
                activeSubSection={subSection}
                topEntity={null}
                user={null}
                usedByDesigner={false}
                isEng={this.props.isEng}
                editable={editable}
                callback={() => this.props.callbackElement(subSection.parent.parent)}
              />
            </div>
          </div>
        )
      } else {
        controlArray.push(
          <div style={{ textAlign: 'center' }}>
            <div style={{ width: '100%' }}>{field.ENUTitle}</div>
            <div style={{ width: '100%' }}> 
              <ElementListComponent key={'sub_' + field.Id} {...this.props}
                field={this.props.field}
                usedByDesigner={false} 
                activeSubSection={subSection}
                topEntity={null}
                user={null} 
                editable={false}
                isEng={this.props.isEng}
                callback={() => this.props.callbackElement(subSection.parent.parent)}
              />
            </div>
          </div>)
      }
    });

    return controlArray;

  }
}